import AgentsEvents from '../api/agentsEvents'
import { SAVE_EVENT, UPDATE_EVENT } from './actions.types'
import { SET_END, SET_EVENT, SET_START } from './mutation.types'

const agentsEvents = {
  namespaced: true,
  state: {
    event: null,
    start: null,
    end: null
  },
  mutations: {
    [SET_EVENT]: (state, event) => {
      state.event = event
    },
    [SET_START]: (state, start) => {
      state.start = start
    },
    [SET_END]: (state, event) => {
      state.end = event
    }
  },
  actions: {
    [SAVE_EVENT]: async ({ commit, state }, event) => {
      try {
        let response = await AgentsEvents.save({
          ...state,
          event
        })
        console.log('EVENT SAVED', response)
        commit(SET_EVENT, event)
      } catch (e) {
        throw e
      }
    },
    [UPDATE_EVENT]: async (
      { commit, state },
      { event, updateCopies = false }
    ) => {
      try {
        let response = await AgentsEvents.update({
          ...state,
          event,
          updateCopies
        })
        console.log('EVENT SAVED', response)
        commit(SET_EVENT, event)
      } catch (e) {
        throw e
      }
    }
  }
}

export default agentsEvents
